import React, { useState, useEffect } from 'react'
import NumberFormat from 'react-number-format';
import { Row, Col, Input, Button } from 'reactstrap'

const ValoresCobertura = ({ data, i, handleBack, handleClick, final, idCobertura, cliCodigoCore, mostrarRotura, estadoActualizar, setEstadoActualizar, hasSiguienteUbicacion }) => {
    const [datos, setDatos] = useState(data);
    const cambiarDatos = async (value, j) => {
        const value2 = parseFloat(datos[j].value)
        const valor = parseFloat(datos[j].valor)
        if (value >= 0 && value2 !== value && value <= valor) {
            let data = [...datos]
            data[j] = { ...datos[j], value }
            setEstadoActualizar(true)
            setDatos(data)
        }
    }

    useEffect(() => {
        setDatos(data)
    }, [data])

    return (
        <div>
            {datos.map(({ codigo, descripcion, valor, value }, j) =>
                <div key={'dataubicaciones' + i + '-' + j}>
                    <Row >
                        <Col xs={6} sm={4} > <p style={{ color: (codigo === "maximoDespachadores" ? '#989898' : 'black') }} >{`${codigo}` === 'maximoDespachadores' ?
                            descripcion.replace('{X}', (`${codigo}` === 'maximoDespachadores' ? data.find(item => item.codigo === 'numeroDespachadores').value : '') | 0) : descripcion} </p> </Col>
                        <Col xs={6} sm={5}>
                            <NumberFormat
                                className="form-control"
                                disabled={codigo === "maximoDespachadores"} 
                                value={value > valor ? 0 : value}
                                thousandSeparator={','}
                                decimalSeparator={'.'}
                                style={{ width: 'inherit', fontSize: 20, textAlign: 'right', 
                                        background: (codigo === "maximoDespachadores" ? '#f5f5f5' : '') }} 
                                decimalScale={2}
                                prefix={''}
                                onValueChange={(valor, e) => {

                                    console.log('Valor', valor)
                                    cambiarDatos(valor.floatValue, j)


                                }}

                            />
                        </Col>
                        <Col sm={3}> <p style={{ textAlign: 'right', color: '#909090', color: (codigo === "maximoDespachadores" ? '#989898' : '') }}>{valor.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</p> </Col>
                    </Row>

                </div>
            )}
            <div className='flex' style={{ margin: 10, }}  >
                <Button className="btn btn-detail-gray" onClick={() => handleBack()} style={{ margin: "auto" }} >
                    <i className="fa fa-chevron-circle-left" aria-hidden="true" />{"  REGRESAR"}
                </Button>
                <Button disabled={estadoActualizar ? false : !hasSiguienteUbicacion} className={estadoActualizar ? 'btn btn-purple fe-pulse' : 'btn btn-primary'} onClick={() => { handleClick(datos, i) }} style={{ margin: "auto", }} >
                    <i className="fa fa-chevron-circle-right " aria-hidden="true" />{ estadoActualizar ? ' ACTUALIZAR VALORES' : ' SIGUIENTE' }
                </Button>
            </div>
        </div>
    )
}

export default ValoresCobertura